/* Timber custom: overlay page scrollbar — a floating tan pill painted over
   the content (no gutter, so nothing ever shifts). The native viewport bar
   is hidden in base.css (desktop fine-pointer devices only); this keeps the
   pill sized and positioned, shows it while scrolling or dragging, and lets
   it fade out ~1s after. The pill itself is draggable, replacing the native
   bar's drag affordance. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var root = document.documentElement;
  var bar;
  var thumb;
  var timer = null;
  var dragging = false;
  var dragStartY = 0;
  var dragStartScroll = 0;

  function metrics() {
    var scrollHeight = root.scrollHeight;
    var clientHeight = root.clientHeight;
    var max = scrollHeight - clientHeight;
    if (max <= 0) {
      bar.style.display = 'none';
      return null;
    }
    bar.style.display = '';
    var trackHeight = bar.clientHeight;
    var thumbHeight = Math.max(32, Math.round((clientHeight / scrollHeight) * trackHeight));
    return {
      max: max,
      trackHeight: trackHeight,
      thumbHeight: thumbHeight,
      y: Math.round((window.scrollY / max) * (trackHeight - thumbHeight)),
    };
  }

  function paint() {
    var m = metrics();
    if (!m) return;
    thumb.style.height = m.thumbHeight + 'px';
    thumb.style.transform = 'translateY(' + m.y + 'px)';
  }

  function show() {
    root.classList.add('timber-scrolling');
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      if (!dragging) root.classList.remove('timber-scrolling');
    }, 1000);
  }

  function init() {
    bar = document.createElement('div');
    bar.className = 'timber-scrollbar';
    bar.setAttribute('aria-hidden', 'true');
    thumb = document.createElement('div');
    thumb.className = 'timber-scrollbar__thumb';
    bar.appendChild(thumb);
    document.body.appendChild(bar);

    window.addEventListener(
      'scroll',
      function () {
        show();
        paint();
      },
      { passive: true }
    );
    window.addEventListener('resize', paint);

    thumb.addEventListener('pointerdown', function (event) {
      dragging = true;
      dragStartY = event.clientY;
      dragStartScroll = window.scrollY;
      thumb.setPointerCapture(event.pointerId);
      show();
      event.preventDefault();
    });
    thumb.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var m = metrics();
      if (!m) return;
      var range = m.trackHeight - m.thumbHeight;
      if (range <= 0) return;
      window.scrollTo(0, dragStartScroll + ((event.clientY - dragStartY) / range) * m.max);
    });
    thumb.addEventListener('pointerup', function () {
      dragging = false;
      show();
    });

    paint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
